import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "border-2 border-orange border-solid"
};
const _hoisted_2 = { class: "max-h-144 overflow-y-scroll" };
const _hoisted_3 = { class: "flex justify-between items-center p-4 bg-gray-light even:bg-white" };
const _hoisted_4 = {
    key: 1,
    class: "border-2 border-orange border-solid"
};
const _hoisted_5 = { class: "flex flex-wrap" };
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["onClick"];
const _hoisted_8 = { class: "h-96 overflow-y-scroll" };
const _hoisted_9 = { class: "flex justify-between items-center p-4 bg-gray-light even:bg-white" };
const _hoisted_10 = { class: "flex" };
const _hoisted_11 = ["href"];
import { computed, ref, toRef, watch } from "vue";
import FolderIcon from "./icons/FolderIcon.vue";
import DocumentIcon from "./icons/DocumentIcon.vue";
import TrashIcon from "./icons/TrashIcon.vue";
import { PencilIcon } from '@heroicons/vue/24/solid';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ProjectsComponent',
    props: {
        filesList: {
            type: Object
        },
        projectname: {
            type: String
        },
        projects: {
            type: Object
        },
    },
    emits: ["onRemoveProject", "onRemoveElement", "onReadExcel", "onSubmitForm", "onDownload", "onEdit"],
    setup(__props, { emit: emits }) {
        const props = __props;
        const projectFiles = toRef(props, 'filesList');
        //const projectNamed = toRef(props, 'projectname');
        const selectedItem = ref(0);
        let filteredFiles = ref([]);
        let filterParam = ref('xml');
        let isActive = false;
        const tabItems = [{ value: 'xml', name: 'Rezepte' }, { value: 'pdf', name: 'PDF-Dateien' }, { value: 'jpg', name: 'Bilder' }, { value: 'xls', name: 'Excel-Datei' }];
        const selectItem = (i) => {
            selectedItem.value = i;
            tabItems.forEach((item, index) => {
                return (isActive = item == tabItems[index]);
            });
            return selectedItem;
        };
        const removeProject = (project) => {
            emits('onRemoveProject', project);
        };
        const removeElement = (projectFile) => {
            emits('onRemoveElement', projectFile.filename);
            filterParam.value = projectFile.extension;
        };
        const readExcel = (projectFile) => {
            emits('onReadExcel', projectFile.filename);
        };
        const redirectTo = (projectFile) => {
            emits('onSubmitForm', projectFile.filename);
        };
        const downloadFile = (projectFile) => {
            emits('onDownload', projectFile.filename);
        };
        const editElement = (projectFile) => {
            emits('onEdit', projectFile.filename);
        };
        const changeFilterTo = (search) => {
            filterParam.value = search;
            if (projectFiles.value) {
                const filtered = computed(() => projectFiles.value.filter((file) => {
                    if (file.extension === 'xml') {
                        file.flag = setFlag(file.basename);
                    }
                    if (file.extension === 'pdf') {
                        file.actionlink = true;
                    }
                    return file.extension.toLowerCase().includes(search.toLowerCase());
                }));
                filteredFiles.value = filtered.value;
            }
        };
        const setFlag = (search) => {
            let result = false;
            projectFiles.value.forEach((file) => {
                if (file.filename === search + '.pdf') {
                    result = true;
                }
            });
            return result;
        };
        watch(projectFiles, (files) => {
            if (files === null || files === void 0 ? void 0 : files.length) {
                changeFilterTo(filterParam.value);
                //selectedItem.value = 0;
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (__props.projects)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
                        _createElementVNode("ul", _hoisted_2, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.projects, (project) => {
                                return (_openBlock(), _createElementBlock("li", _hoisted_3, [
                                    _createVNode(FolderIcon, { "project-name": project }, null, 8, ["project-name"]),
                                    _createVNode(TrashIcon, {
                                        onClick: ($event) => (removeProject(project))
                                    }, null, 8, ["onClick"])
                                ]));
                            }), 256))
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (_unref(projectFiles))
                    ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
                        _createElementVNode("ul", _hoisted_5, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabItems, (item, index) => {
                                return _createElementVNode("li", {
                                    class: _normalizeClass(["mr-2", { 'bg-orange': index === selectedItem.value }]),
                                    key: index,
                                    onClick: ($event) => (selectItem(index))
                                }, [
                                    _createElementVNode("span", {
                                        onClick: ($event) => (changeFilterTo(item.value)),
                                        class: "inline-block py-4 px-4 text-sm font-medium text-center cursor-pointer"
                                    }, _toDisplayString(item.name), 9, _hoisted_7)
                                ], 10, _hoisted_6);
                            }), 64))
                        ]),
                        _createElementVNode("ul", _hoisted_8, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredFiles), (projectFile) => {
                                return (_openBlock(), _createElementBlock("li", _hoisted_9, [
                                    _createVNode(DocumentIcon, {
                                        projectFile: projectFile,
                                        onOnReadItem: readExcel,
                                        onOnRedirect: redirectTo,
                                        onOnDownload: downloadFile
                                    }, null, 8, ["projectFile"]),
                                    _createElementVNode("div", _hoisted_10, [
                                        (projectFile.extension === 'xml')
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 0,
                                                href: '/editxml/' + __props.projectname + '/' + projectFile.basename
                                            }, [
                                                _createVNode(_unref(PencilIcon), { class: "mr-2 h-5 w-5 text-orange" })
                                            ], 8, _hoisted_11))
                                            : _createCommentVNode("", true),
                                        _createVNode(TrashIcon, {
                                            onClick: ($event) => (removeElement(projectFile))
                                        }, null, 8, ["onClick"])
                                    ])
                                ]));
                            }), 256))
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
